
import {defineComponent} from "vue"
import Menubar from "primevue/menubar";
import {Locales, LOCALES} from "@/i18n/locales";
import Dropdown from "primevue/dropdown";
import axios from "axios";
import {checkUserAdminRoleURL} from "@/config/app-settings";
import Button from "primevue/button";


export default defineComponent({
  name: "Header",
  components: {Menubar, Dropdown, Button},
  data() {
    return {
      isReady: false as Boolean,
      LOCALES, Locales,
      items: [] as any[]
    }
  },
  methods: {
    updateLanguage(e: any) {
      this.$store.commit('setLang', e.value.value)
      this.items = this.loadHeaderItems()
      this.checkIfUserIsAdmin()
    },
    goToRoute(r: string) {
      if (r === 'Login') {
        this.$store.dispatch('logout')
        this.$router.push({name: 'Login'})
      } else {
        if (['new'].includes(this.$store.state.formState)) {
          this.$router.push({name: r})
        }
      }
    },
    checkIfUserIsAdmin() {
      this.isReady = false
      axios.get(checkUserAdminRoleURL).then(res => {
        if (res.data == true) {
          this.items.splice(1, 0, {
            label: 'expertValidation',
            icon: 'pi pi-check-square',
            route: 'ExpertValidation'
          });
          this.isReady = true
        } else {
          // not an admin
          this.isReady = true
        }
      }).catch(err => {
        console.log("error:", err)
        this.isReady = true
      })
    },
    loadHeaderItems() {
      return [
        {separator: true},
        {
          label: this.$store.getters.fullName,
          icon: 'pi pi-user',
          route: 'Profile'
        },
        {
          label: 'Logout',
          icon: 'pi pi-external-link',
          route: 'Login'
        }
      ]
    }
  },
  mounted() {
    this.$store.state.menubarClicked = false
    this.items = this.loadHeaderItems()
    // check if logged in user has admin role and hide/display validation page accordingly
    this.checkIfUserIsAdmin()
  }
})
